'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getBodySize;

var _sizes = require('../constants/sizes');

function getBodySize(screen, width) {
    if (screen.isMobile) {
        return 375;
    } else if (screen.isTablet) {
        return 768;
    } else if (screen.isDesktop) {
        if (width) {
            switch (width) {
                case _sizes.Sizes.md:
                    return 660;
                case _sizes.Sizes.xxl:
                    return Math.min(1366, screen.viewWidth);
                case _sizes.Sizes.lg:
                case _sizes.Sizes.xl:
                default:
                    return 1080;
            }
        } else {
            return 1080;
        }
    }
}